import {
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  List,
  ListItem,
  Link,
} from 'framework7-react';
import { useEffect, useState, useCallback } from 'react';
import { getCurrentUser, getDocument } from '../firebase';
import '@styles/AccountInfo.css';
import LeadingIcon from '@assets/icons/Leading.svg?react';

function AccountPage() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const fetchUser = useCallback(async () => {
    console.log('fetchUser called');
    const user = await getCurrentUser();
    if (!user) {
      console.log('fetchUser: no authenticated user');
      return;
    }

    setEmail(user.email || '');

    try {
      console.log(`Fetching document for users/${user.uid}`);
      const snap = await getDocument(`users/${user.uid}`);
      console.log('Document fetched', { exists: snap.exists(), data: snap.data() });
      if (snap.exists()) {
        const data = snap.data() as {
          fullName?: string;
          email?: string;
          phoneNumber?: string;
        };
        if (data.email) setEmail(data.email);
        if (data.phoneNumber) setPhoneNumber(data.phoneNumber);
        if (data.fullName) {
          setFullName(data.fullName);
          return;
        }
      }
      const name = user.email?.split('@')[0] || 'User';
      setFullName(name.charAt(0).toUpperCase() + name.slice(1));
    } catch (err) {
      console.error('Error fetching user info', err);
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <Page name="account" className="account-page" onPageAfterIn={fetchUser}>
      <Navbar className="no-outline">
        <NavLeft>
          <Link back className="icon-only" aria-label="Back">
            <LeadingIcon />
          </Link>
        </NavLeft>
        <NavTitle>Account info</NavTitle>
        
      </Navbar>

      <List className="account-list">
        <ListItem
          title={fullName}
          header="Full Name"
          link="/account-name"
        />
        <ListItem
          title={email || 'Not set'}
          header="Email address"
          link="/email"
        />
        <ListItem
          title={phoneNumber || 'Not set'}
          header="Phone number"
          link="/account-phone"
        />
        <ListItem
          title="Change password"
          header="Password"
          link="/change-password"
        />
      </List>
    </Page>
  );
}

export default AccountPage;
